const REDACTED_VALUE = '[REDACTED]';

const buildApiErrorTelemetryProperties = (error: any) => {
  const shouldRedact = error?.config?.redactErrorTelemetry === true;

  return {
    error: error?.message,
    status: error?.response?.status || 'Unknown',
    statusText: shouldRedact
      ? error?.response?.statusText || ''
      : error?.response?.statusText ||
        error?.response?.data?.message ||
        error?.request?.responseText ||
        '',
    responseBody: shouldRedact ? REDACTED_VALUE : error?.response?.data,
    config: {
      data: shouldRedact ? REDACTED_VALUE : error?.config?.data,
      // Never kept: they carry the signed-in user's bearer token.
      headers: REDACTED_VALUE,
      maxBodyLength: error?.config?.maxBodyLength,
      maxContentLength: error?.config?.maxContentLength,
      method: error?.config?.method,
      params: shouldRedact ? REDACTED_VALUE : error?.config?.params,
      timeout: error?.config?.timeout,
      url: error?.config?.url,
    },
  };
};

export default buildApiErrorTelemetryProperties;
